import SectionHeading from "../ui/SectionHeading";

type SkillGroup = {
  label: string;
  skills: string[];
};

const SkillsSection = ({ skills }: { skills: SkillGroup[] }) => (
  <section className="skills-section section-shell" id="skills">
    <SectionHeading
      index="04"
      label="Capabilities / toolkit"
      title="A broad stack, organised around shipping complete products."
      align="right"
    />

    <div className="skills-index">
      {skills.map((group, index) => (
        <article className="skills-index__row" key={group.label} data-reveal>
          <span>{String(index + 1).padStart(2, "0")}</span>
          <h3>{group.label}</h3>
          <ul>
            {group.skills.map((skill) => (
              <li key={skill}>{skill}</li>
            ))}
          </ul>
        </article>
      ))}
    </div>

    <div className="skills-marquee" aria-hidden="true">
      <div>
        <span>React</span>
        <span>TypeScript</span>
        <span>React Native</span>
        <span>NestJS</span>
        <span>Flutter</span>
        <span>Node.js</span>
        <span>PostgreSQL</span>
        <span>UI / UX</span>
        <span>React</span>
        <span>TypeScript</span>
        <span>React Native</span>
        <span>NestJS</span>
      </div>
    </div>
  </section>
);

export default SkillsSection;
